/* A simple interface to access quill instances */

class QuillRegistry {
  constructor() {
    this.registry = new Map()
  }

  register(id, instance) {
    this.registry.set(id, instance)
  }

  unregister(id) {
    this.registry.delete(id)
  }

  get(id) {
    return this.registry.get(id)
  }
}

const quillRegistry = new QuillRegistry()

export default quillRegistry
